import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ADMIN_PATH } from '../config/adminRoutes';
import { CONSENT_EVENT, getConsent } from '../lib/cookieConsent';
import { disableGoogleAnalytics, initializeGoogleAnalytics } from '../lib/googleAnalytics';

function GoogleAnalytics() {
    const { pathname } = useLocation();
    useEffect(() => {
        if (pathname.startsWith(ADMIN_PATH)) {
            disableGoogleAnalytics();
            return undefined;
        }
        const enable = () => initializeGoogleAnalytics(pathname);
        const handleConsent = (event) => {
            if (event.detail?.analytics) {
                enable();
            } else {
                disableGoogleAnalytics();
            }
        };

        if (getConsent()?.analytics) enable();
        window.addEventListener(CONSENT_EVENT, handleConsent);
        return () => window.removeEventListener(CONSENT_EVENT, handleConsent);
    }, [pathname]);

    return null;
}

export default GoogleAnalytics;
